// WHO OWNS THIS ORIGIN'S SESSION (review D1, 2026-10-09; Nika: "No, avoid the
// sign-out").
//
// `symbols_session_source` in localStorage:
//   'own'    — a sign-in on THIS origin wrote the refresh token (password,
//              magic link, OAuth, signup, demo, white-label, handoff). This
//              origin refreshes it and signs out when the server refuses it.
//   'bridge' — the access token was adopted from the `/_session-bridge` peer
//              (sessionBridgeReacquire.js). No refresh token here; ask again.
//   absent   — nothing marked it. A refresh token without a mark on the
//              BORROWING origin (the canvas) is a copy an older bridge build
//              handed over: sdkClient asks the bridge first and only falls back
//              to the token when the bridge has no session — never a sign-out.
//
// `markOwnSession()` is called after every sign-in that stores a refresh
// token. The SDK's TokenManager writes the same mark on its own once it ships
// (sdk branch fix/token-manager-session-reacquirer); this covers the
// published SDK and the paths that write storage directly.
//
// FA204 / frank trap — self-contained.

export const markOwnSession = () => {
  try {
    if (typeof localStorage === 'undefined' || !localStorage) return false
    if (!localStorage.getItem('symbols_refresh_token')) return false
    localStorage.setItem('symbols_session_source', 'own')
    return true
  } catch {
    return false
  }
}
